export const createTenantStructureLoader = (onSnapshot, fetcher = fetch) => {
  let currentRequest = null

  const cancel = () => {
    currentRequest?.abort()
    currentRequest = null
  }

  const refresh = async (options) => {
    cancel()
    const request = new AbortController()
    currentRequest = request
    const { apiBase, tenantId, authHeaders, includeDeleted } = options
    const query = new URLSearchParams({ tenant_id: tenantId })
    if (includeDeleted) query.set('include_deleted', '1')
    try {
      const [companies, sites, posList] = await Promise.all(
        ['companies', 'sites', 'pos'].map(async (entity) => {
          const response = await fetcher(`${apiBase}/tenant/${entity}?${query}`, {
            headers: authHeaders,
            cache: 'no-store',
            signal: request.signal
          })
          if (!response.ok) throw new Error(`HTTP ${response.status}`)
          const rows = await response.json()
          if (!Array.isArray(rows)) throw new Error('Invalid tenant structure response')
          return rows
        })
      )
      if (currentRequest !== request || request.signal.aborted) return
      onSnapshot({
        companies: companies.filter((company) => !company.is_deleted),
        sites: sites.filter((site) => !site.is_deleted),
        posList: posList.filter((pos) => !pos.is_deleted),
        companiesWithDeleted: includeDeleted ? companies : [],
        sitesWithDeleted: includeDeleted ? sites : [],
        posListWithDeleted: includeDeleted ? posList : []
      }, options)
    } catch (error) {
      if (currentRequest === request && !request.signal.aborted) throw error
    }
  }

  return { refresh, cancel }
}
